const shasaStores = [
  {
    distance: 0,
    code: "T001",
    cluster: "centrocold",
    name: "CDMX, PLAZA UNIVERSIDAD",
    latitude: 19.3670925217234, longitude: -99.1659731944738,
    address: "Av. Universidad #1000 Col. Santa Cruz Atoyac, Benito Juarez, CDMX"
  },{
    distance: 0,
    code: "T003",
    cluster: "centrocold",
    name: "CDMX, SANTA FE",
    latitude: 19.3609656547412, longitude: -99.2741284355788,
    address: "Av. Vasco de Quiroga 3800 Col. Antigua Mina La Totolapa, Cuajimalpa, CDMX"
  },{
    distance: 0,
    code: "T004",
    cluster: "centrocold",
    name: "CDMX, GALERIAS INSURGENTES",
    latitude: 19.3724493530738, longitude: -99.1786018992495,
    address: "Av. Insurgentes Sur 1352 Int. L-173 Col. Actipan, Benito Juarez, CDMX"
  },{
    distance: 0,
    code: "T005",
    cluster: "centrocold",
    name: "CDMX, GALERIAS COAPA",
    latitude: 19.3022698251371, longitude: -99.1236328183988,
    address: "Av.Calz. Del Hueso 519 L117 Col. Residencial Acoxpa, Tlalpan, CDMX"
  },{
    distance: 0,
    code: "T006",
    cluster: "calor",
    name: "VILLAHERMOSA, GAL TABASCO 2000",
    latitude: 18.0009546305867, longitude: -92.9462394486736,
    address: "Av. Prol. Paseo Tabasco 1405 Col. Galaxia-Tabasco 2000, Centro, VILLAHERMOSA"
  },{
    distance: 0,
    code: "T007",
    cluster: "centrocold",
    name: "TLALNEPANTLA, MUNDO E",
    latitude: 19.5258016478538, longitude: -99.2276143478509,
    address: "Blvd.Manuel Avila Camacho 1007 Col. San Lucas Tepetlacalco, Tlanepantla de Baz, TLALNEPANTLA"
  },{
    distance: 0,
    code: "T008",
    cluster: "turistica",
    name: "CANCÚN, LA ISLA",
    latitude: 21.1111004559767, longitude: -86.7637096454634,
    address: "Blvd. Kukulkan #262 Int. LB-4 Zona Hotelera, Cancun Q Roo, Benito Juarez, CANCÚN"
  },
  // {
  //   distance: 0,
  //   code: "T009",
  //   cluster: "centrocold",
  //   name: "METEPEC, GALERIAS METEPEC",
  //   latitude: 19.2597301283739, longitude: -99.6208926705409,
  //   address: "Blvd. Toluca-Ixtapan 126 Nte. Col. La Purísima Metepec, Metepec, METEPEC"
  // },
  {
    distance: 0,
    code: "T011",
    cluster: "calor",
    name: "MÉRIDA, LAS AMÉRICAS MÉRIDA",
    latitude: 20.9921490251402, longitude: -89.6493950349635,
    address: "Calle 21 No 327 Int. 1,2,3 y 4 Col. Miguel Hidalgo, Mérida, MÉRIDA"
  },{
    distance: 0,
    code: "T012",
    cluster: "turistica",
    name: "MORELIA, LAS AMÉRICAS MORELIA",
    latitude: 19.6888854101414, longitude: -101.158120714112,
    address: "Av.Lic.Enrique Ramirez Miguel Col. Las Americas, Morelia, MORELIA"
  },{
    distance: 0,
    code: "T014",
    cluster: "nortecold",
    name: "PUEBLA, ANGELOPOLIS",
    latitude: 19.031848132049, longitude: -98.2327367934345,
    address: "Blvd. Del Nino Poblano 2510 Col. Concepcion La Cruz, Puebla, PUEBLA"
  },{
    distance: 0,
    code: "T015",
    cluster: "bajiocold",
    name: "PACHUCA, GALERÍAS PACHUCA",
    latitude: 20.098249843494, longitude: -98.7683574371683,
    address: "Camino Real de la Plata 100 Col. Zona Plateada Pachuca, Pachuca de Soto, PACHUCA"
  },{
    distance: 0,
    code: "T016",
    cluster: "centrocold",
    name: "CDMX, PERISUR",
    latitude: 19.3039952338355, longitude: -99.1904682801345,
    address: "Av. Anillo Periferico Sur 4690 Col. Insurgentes Cuicuilco, Coyoacán, CDMX"
  },{
    distance: 0,
    code: "T017",
    cluster: "nortecold",
    name: "ORIZABA, PLAZA VALLE",
    latitude: 18.8631293512299, longitude: -97.0970320071529,
    address: "Av. Circunvalacion Norte S/N Col. Espinal, Orizaba, ORIZABA"
  },{
    distance: 0,
    code: "T018",
    cluster: "calor",
    name: "CHETUMAL,LAS AMÉRICAS CHETUMAL",
    latitude: 18.5204888098823, longitude: -88.3231204389594,
    address: "Av. Insurgentes KM 5.025 Chetumal, Othon P. Blanco, CHETUMAL"
  },{
    distance: 0,
    code: "T019",
    cluster: "bajiocold",
    name: "QUERÉTARO, GALERIAS QUERETARO",
    latitude: 20.5778526720538, longitude: -100.405956988347,
    address: "Av. 5 Febrero Sur SN Loc. 221 Col. Los Virreyes, Querétaro, QUERÉTARO"
  },{
    distance: 0,
    code: "T022",
    cluster: "calor",
    name: "CULIACÁN, FORUM CULIACÁN",
    latitude: 24.8143852265017, longitude: -107.400607007389,
    address: "Blvd. Jose Diego Valdez Rios Col. Desarrollo Urbano, Culiacán, CULIACÁN"
  },{
    distance: 0,
    code: "T023",
    cluster: "calor",
    name: "CANCÚN, CANCÚN MALL",
    latitude: 21.1828939949649, longitude: -86.8511312300735,
    address: "Calle. Supermanzana 228 Mz. 22 Col. Zona Hotelera, Benito Juarez, CANCÚN"
  },{
    distance: 0,
    code: "T024",
    cluster: "turistica",
    name: "CUERNAVACA,GALERÍAS CUERNAVACA",
    latitude: 18.9355998824974, longitude: -99.1925987128871,
    address: "Autop. Mex- Acapulco Km 87.85 Col. Ricardo Flores Magon, Cuernavaca, CUERNAVACA"
  },{
    distance: 0,
    code: "T025",
    cluster: "centrocold",
    name: "CDMX, PARQUE DELTA",
    latitude: 19.4035385043849, longitude: -99.1537508413406,
    address: "Av. Cuauhtemoc No. 462 Col. Narvarte, Benito Juarez, CDMX"
  },{
    distance: 0,
    code: "T026",
    cluster: "centrocold",
    name: "ECATEPEC,LAS AMÉRICAS ECATEPEC",
    latitude: 19.5836162764446, longitude: -99.0231650294478,
    address: "Av. Central SN Mz 4 Lt1-2 Col. Conj. Urbano Las Americas, Ecatepec, ECATEPEC"
  },{
    distance: 0,
    code: "T027",
    cluster: "centrocold",
    name: "LERMA, LAS PLAZAS OUTLET",
    latitude: 19.2828437281447, longitude: -99.5000293527567,
    address: "Carr. Mexico-Toluca Km 50 Col. La Isla Lerma, Lerma, LERMA"
  },{
    distance: 0,
    code: "T028",
    cluster: "turistica",
    name: "LOS CABOS, PUERTO PARAISO",
    latitude: 22.8876688811565, longitude: -109.909112017505,
    address: "Lazaro Cardenas y Cabo Bello Col. El Medano, LOS CABOS, LOS CABOS"
  },{
    distance: 0,
    code: "T029",
    cluster: "nortecold",
    name: "XALAPA, LAS AMÉRICAS XALAPA",
    latitude: 19.3412128928567, longitude: -96.5091203786193,
    address: "Carr. Federal Xalapa Veracruz Col. Pastoressa, Xalapa, XALAPA"
  },{
    distance: 0,
    code: "T030",
    cluster: "bajiocold",
    name: "CELAYA, GALERIAS CELAYA",
    latitude: 20.5316079430335, longitude: -100.779447735589,
    address: "Av. Nor-Oriente 200 Int. 216 Col. Compuertas del Campestre, Celaya, CELAYA"
  },{
    distance: 0,
    code: "T031",
    cluster: "centrocold",
    name: "CDMX, METRÓPOLI PATRIOTISMO",
    latitude: 19.3963724048845, longitude: -99.1806181457248,
    address: "Avenida Patriotismo 229 Col. San Pedro de los Pinos, Benito Juarez, CDMX"
  },{
    distance: 0,
    code: "T032",
    cluster: "calor",
    name: "COATZACOALCOS, FÓRUM CTZ",
    latitude: 18.1421044314453, longitude: -94.4884552774104,
    address: "Av. Universidad Km 8 Int. PB12 Carr. Antigua Minatitlan S/N, Coatzacoalcos, COATZACOALCOS"
  },{
    distance: 0,
    code: "T033",
    cluster: "calor",
    name: "CANCÚN, GRAN PLAZA",
    latitude: 21.1401896219118, longitude: -86.8542687797749,
    address: "Av. Nichupe Mza 18 LT-1-04 Col. Supermanzana 51, Benito Juarez, CANCÚN"
  },{
    distance: 0,
    code: "T034",
    cluster: "turistica",
    name: "PLAYA DEL CARMEN, CENTRO MAYA",
    latitude: 20.6187582456511, longitude: -87.0958543128673,
    address: "Calle. 41 Sur No 2100 Lote 031 Col. Ejidal Playa del Carmen, Solidaridad, PLAYA DEL CARMEN"
  },{
    distance: 0,
    code: "T035",
    cluster: "centrocold",
    name: "CDMX, PARQUE LINDAVISTA",
    latitude: 19.48591382269, longitude: -99.1315157974062,
    address: "Colectores 13 No.280 L101-102 Col. Magdalena de las Salinas, Gustavo A. Madero, CDMX"
  },{
    distance: 0,
    code: "T036",
    cluster: "bajiocold",
    name: "IRAPUATO, PLAZA CIBELES",
    latitude: 20.6810034338767, longitude: -101.379659525626,
    address: "Blvd a Villas de Irapuato 1443 Col. Ejido Irapuato, Irapuato, IRAPUATO"
  },{
    distance: 0,
    code: "T037",
    cluster: "calor",
    name: "COLIMA, ZENTRALIA COLIMA",
    latitude: 19.2675529222924, longitude: -103.698030411285,
    address: "Paseo Miguel de la Madrid 301 Col. Valle Dorado, Colima, COLIMA"
  },{
    distance: 0,
    code: "T038",
    cluster: "nortecold",
    name: "TEHUACÁN, PASEO TEHUACÁN",
    latitude: 18.4679065194201, longitude: -97.417879268934,
    address: "Av. Adolfo Lopez Mateos 3800 Col. Sn Lorenzo Teotipilco, Tehuacán, TEHUACÁN"
  },{
    distance: 0,
    code: "T039",
    cluster: "centrocold",
    name: "ECATEPEC, PLAZA ARAGÓN",
    latitude: 19.5316748938568, longitude: -99.0263755241025,
    address: "Av.Carlos Hank Gonzalez 120 Col. Rinconada de Aragon, Ecatepec, ECATEPEC"
  },{
    distance: 0,
    code: "T040",
    cluster: "centrocold",
    name: "NAUCALPAN, PLAZA SATÉLITE",
    latitude: 19.5098141297276, longitude: -99.234576180801,
    address: "Calle Circuito C.C. No. 2251 Col. Ciudad Satelite, Naucalpan, NAUCALPAN"
  },{
    distance: 0,
    code: "T041",
    cluster: "bajiocold",
    name: "CELAYA, PARQUE CELAYA",
    latitude: 20.5475639863454, longitude: -100.838121725268,
    address: "Eje Nor Poniente No. 801 Col. 15 de Mayo, Celaya, CELAYA"
  },{
    distance: 0,
    code: "T042",
    cluster: "turistica",
    name: "PLAYA DEL CARMEN, LAS AMERICAS",
    latitude: 20.6481714220597, longitude: -87.0817236527247,
    address: "Carr. Federal Chetumal Km 291 Playa del Carmen, Solidaridad, PLAYA DEL CARMEN"
  },{
    distance: 0,
    code: "T043",
    cluster: "centrocold",
    name: "CDMX, PARQUE TEZONTLE",
    latitude: 19.3842976654785, longitude: -99.0827648719505,
    address: "Av. Canal de Tezontle No. 1512 Col. Dr. Alfonso Ortiz Tirado, Iztapalapa, CDMX"
  },{
    distance: 0,
    code: "T044",
    cluster: "bajiocold",
    name: "AGUASCALIENTES, ALTARIA",
    latitude: 21.9236482867705, longitude: -102.28959774171,
    address: "Blvd.a Zacatecas Norte No. 849 Col. Trojes de Alonso, Aguascalientes, AGUASCALIENTES"
  },{
    distance: 0,
    code: "T045",
    cluster: "calor",
    name: "MÉRIDA, GALERÍAS MÉRIDA",
    latitude: 21.0399973944705, longitude: -89.6314970000063,
    address: "Calle 60 No. 299 X3 y 3A Col. Revolucion, Mérida, MÉRIDA"
  },{
    distance: 0,
    code: "T046",
    cluster: "turistica",
    name: "PUERTO VALLARTA,GALERIAS VLL",
    latitude: 20.6578937655091, longitude: -105.239032430615,
    address: "Blvd. Fco.Medina Ascencio 2920 Col. Educacion, Puerto Vallarta, PUERTO VALLARTA"
  },{
    distance: 0,
    code: "T047",
    cluster: "nortecold",
    name: "DURANGO, PASEO DURANGO",
    latitude: 24.0360727613064, longitude: -104.651021542331,
    address: "Av. Felipe Pescador No. 1401 Col. Esperanza, Durango, DURANGO"
  },{
    distance: 0,
    code: "T048",
    cluster: "bajiocold",
    name: "GUADALAJARA, GRAN PLAZA",
    latitude: 20.673022555878624, longitude: -103.404328160132,
    address: "Av.Vallarta No. 3959 Col. Don Bosco Vallarta, Zapopan, GUADALAJARA"
  },{
    distance: 0,
    code: "T049",
    cluster: "calor",
    name: "TUXTLA GTZ, PLAZA LAS AMÉRICAS",
    latitude: 16.7625138203189, longitude: -93.140038432099,
    address: "Av.Quinta Nor Poniente 2651 Col. Tuxtla Gutierrez Centro, Tuxtla Gutierrez, TUXTLA GTZ"
  },{
    distance: 0,
    code: "T050",
    cluster: "centrocold",
    name: "CDMX, PLAZA MADERO",
    latitude: 19.4340364112422, longitude: -99.1389049425976,
    address: "Calle Francisco I Madero No.20 Col. Centro de la CDMX, Cuauhtemoc, CDMX"
  },{
    distance: 0,
    code: "T051",
    cluster: "calor",
    name: "MÉRIDA, ALTABRISA MÉRIDA",
    latitude: 21.0164194310923, longitude: -89.5838690418798,
    address: "Calle Siete No. 451 Int 13 Col. Fraccionamiento Altabrisa, Mérida, MÉRIDA"
  },{
    distance: 0,
    code: "T052",
    cluster: "turistica",
    name: "ACAPULCO, LA ISLA ACAPULCO",
    latitude: 16.7733459374397, longitude: -99.7761534084972,
    address: "Bvld. de las Naciones No.1813 Col. Playa diamente, Acapulco, ACAPULCO"
  },{
    distance: 0,
    code: "T053",
    cluster: "bajiocold",
    name: "GUADALAJARA, GALERÍAS GDL",
    latitude: 20.676766295442, longitude: -103.431155950314,
    address: "Av. Rafael Sanzio No.150 Col. Residencial La Estancia, Zapopan, GUADALAJARA"
  },{
    distance: 0,
    code: "T054",
    cluster: "nortecold",
    name: "TEPIC, FORUM TEPIC",
    latitude: 21.4918373156861, longitude: -104.866960222962,
    address: "Blvd. Luis D. Colosio No. 680 Col. Benito Juarez, Tepic, TEPIC"
  },{
    distance: 0,
    code: "T055",
    cluster: "nortecold",
    name: "TORREÓN, GALERÍAS LAGUNA",
    latitude: 25.5810015675067, longitude: -103.403841401225,
    address: "Av. Periferico Raul Lopez Schz Col. El Fresno, Torreón, TORREÓN"
  },{
    distance: 0,
    code: "T056",
    cluster: "nortecold",
    name: "CHIHUAHUA, FASHION MALL CHIH",
    latitude: 28.6226230382938, longitude: -106.114746949223,
    address: "Prfco de la Juventud 3501 L09 Col. Centro, CHIHUAHUA, CHIHUAHUA"
  },{
    distance: 0,
    code: "T057",
    cluster: "centrocold",
    name: "NEZAHUALCOYOTL, CIUDAD JARDÍN",
    latitude: 19.425311886528, longitude: -99.0288366853789,
    address: "Av.Bordo Xochiaca Poligono 3 Col. Cd. Jardin Bicentenario, Nezahualcóyotl, NEZAHUALCOYOTL"
  },{
    distance: 0,
    code: "T058",
    cluster: "nortecold",
    name: "LOS MOCHIS, PASEO LOS MOCHIS",
    latitude: 25.7844676907836, longitude: -109.003820226998,
    address: "Blvd. Centenario 805 LB36-37 Col. Centro los Mochis, Ahome, LOS MOCHIS"
  },{
    distance: 0,
    code: "T059",
    cluster: "bajiocold",
    name: "GUADALAJARA,OUTLET GUADALAJARA",
    latitude: 20.5226647635622, longitude: -103.483168217867,
    address: "Ctra.Gdl-Morelia Km12.5 L79 Tlajomulco Zuniga, Tlajomulco, GUADALAJARA"
  },{
    distance: 0,
    code: "T060",
    cluster: "centrocold",
    name: "ATIZAPÁN, GALERÍAS ATIZAPÁN",
    latitude: 19.5491276820523, longitude: -99.2741446959973,
    address: "Av.Ruiz Cortinez 255 Mza2 L529 Col. Lomas de Atizapan, Atizapán, ATIZAPÁN"
  },{
    distance: 0,
    code: "T061",
    cluster: "nortecold",
    name: "SALTILLO, GALERÍAS SALTILLO",
    latitude: 25.4573444871289, longitude: -100.980943112893,
    address: "Nazario S.Ortiz Garza2345 L163 Col. Tanque de pena Int, Saltillo, SALTILLO"
  },{
    distance: 0,
    code: "T063",
    cluster: "calor",
    name: "CHILPANCINGO, GAL CHILPANCINGO",
    latitude: 17.5151838506394, longitude: -99.4847003754127,
    address: "Blvd.Rene Juarez C.130 L119 Col. Tepango, Chilpancingo, CHILPANCINGO"
  },{
    distance: 0,
    code: "T065",
    cluster: "turistica",
    name: "CANCUN, MALECON AMERICAS",
    latitude: 21.1472329526719, longitude: -86.8230311309232,
    address: "Calle. SMza. 6 Mz1 lt1 L41-43A Col. Supermanzana 6, Benito Juarez, CANCUN"
  },{
    distance: 0,
    code: "T066",
    cluster: "centrocold",
    name: "CDMX, PLAZA CENTRAL",
    latitude: 19.376576666735, longitude: -99.0955154659018,
    address: "Av.Canal del Rio Churubusco SN Col. Central abasto, Iztapalapa, CDMX"
  },{
    distance: 0,
    code: "T067",
    cluster: "calor",
    name: "TAPACHULA, GALERIAS TAPACHULA",
    latitude: 14.873335, longitude: -92.282638,
    address: "Carr.Tapachula-PtoMadero Km25 Col. Las Hortencias, Tapachula, TAPACHULA"
  },{
    distance: 0,
    code: "T068",
    cluster: "nortecold",
    name: "MONTERREY, PLAZA CUMBRES",
    latitude: 25.7327081781213, longitude: -100.397662877175,
    address: "Av. Hda. Penuelas 6771 Col. Cumbres Las Palmas, Monterrey, MONTERREY"
  },{
    distance: 0,
    code: "T069",
    cluster: "centrocold",
    name: "TEXCOCO, GRAN PATIO TEXCOCO",
    latitude: 19.515949103963, longitude: -98.8669371707366,
    address: "Camino Molino Flores Palmar SN Col. Sta Cruz de Arriba, Texcoco, TEXCOCO"
  },{
    distance: 0,
    code: "T070",
    cluster: "turistica",
    name: "ACAPULCO, GALERIAS DIANA",
    latitude: 16.860477548241, longitude: -99.8734350028412,
    address: "Av.Costera Miguel Aleman 1926 Fracc. Magallanes, Acapulco, ACAPULCO"
  },{
    distance: 0,
    code: "T071",
    cluster: "nortecold",
    name: "MONTERREY, GALERÍAS VALLE OTE",
    latitude: 25.6382436473993, longitude: -100.314525507399,
    address: "Av.Lazaro Cardenas 1000 L1173 Col. Valle del Mirador, Monterrey, MONTERREY"
  },{
    distance: 0,
    code: "T073",
    cluster: "bajiocold",
    name: "TLAQUEPAQUE, FORUM TLAQUEPAQUE",
    latitude: 20.647321709469, longitude: -103.320083574428,
    address: "Marcelino Garcia Barragan 2077 Col. Lomas del Paradero, Guadalajara, TLAQUEPAQUE"
  },{
    distance: 0,
    code: "T074",
    cluster: "bajiocold",
    name: "SAN LUIS POTOSI,PLAZA SAN LUIS",
    latitude: 22.1340031727228, longitude: -101.034350842131,
    address: "Antonio Rocha Cordero 700 Int Col. Lomas del Tec., SAN LUIS POTOSI, SAN LUIS POTOSI"
  },{
    distance: 0,
    code: "T075",
    cluster: "calor",
    name: "VILLAHERMOSA, ALTABRISA VSA",
    latitude: 17.9684832541704, longitude: -92.9267199004738,
    address: "Pfco.Carlos Pellicer Camara129 Col. 1o.de Mayo DUML, Villahermosa, VILLAHERMOSA"
  },{
    distance: 0,
    code: "T076",
    cluster: "centrocold",
    name: "CDMX, FORUM BUENAVISTA",
    latitude: 19.4497954331908, longitude: -99.1512938846589,
    address: "Eje1 Nte Mosqueta 259 PB59 Col. Buenavista, Cuauhtemoc, CDMX"
  },{
    distance: 0,
    code: "T077",
    cluster: "calor",
    name: "TUXTLA GTZ, PLAZA CRYSTAL",
    latitude: 16.7537699629779, longitude: -93.1494275184022,
    address: "Blvd. Belisario Dgez Km 1081 Col. Jardines Tuxtla, Chiapas, TUXTLA GTZ"
  },{
    distance: 0,
    code: "T078",
    cluster: "calor",
    name: "LA PAZ, PASEO LA PAZ",
    latitude: 24.1148182706363, longitude: -110.340830698742,
    address: "Av. Agustin Olachea SN L67-68 Col. Campestre, La Paz, LA PAZ"
  },{
    distance: 0,
    code: "T079",
    cluster: "bajiocold",
    name: "ZACATECAS, GALERÍAS ZACATECAS",
    latitude: 22.7772114956316, longitude: -102.597982606633,
    address: "Blvd. El Bote No. 202 L130 Col. La Escondida, Zacatecas, ZACATECAS"
  },{
    distance: 0,
    code: "T080",
    cluster: "turistica",
    name: "VERACRUZ,LAS AMÉRICAS VERACRUZ",
    latitude: 19.1393961208842, longitude: -96.1066650760741,
    address: "Blvd. Adolfo Ruiz Cortines SN Col. Costa Verde, Boca del Rio, VERACRUZ"
  },{
    distance: 0,
    code: "T081",
    cluster: "turistica",
    name: "VERACRUZ, EL DORADO",
    latitude: 19.0955147781959, longitude: -96.1058199027078,
    address: "Carr. Anton Lizardo No. 7A-8A Col. El Estero, Boca del Rio, VERACRUZ"
  },{
    distance: 0,
    code: "T082",
    cluster: "bajiocold",
    name: "LEÓN, ALTACIA",
    latitude: 21.0931338868361, longitude: -101.626266652758,
    address: "Blvd. Aeropuerto 104 L2034 Col. Cerrillo de Jerez, León, LEÓN"
  },{
    distance: 0,
    code: "T083",
    cluster: "calor",
    name: "CAMPECHE, GALERÍAS CAMPECHE",
    latitude: 19.8566215162039, longitude: -90.5226732495099,
    address: "Av. Pedro Sainz de Baranda SN Col. AH Kim Pech, Campeche, CAMPECHE"
  },{
    distance: 0,
    code: "T084",
    cluster: "centrocold",
    name: "CUATITLÁN IZCALLI, PERINORTE",
    latitude: 19.6027862112138, longitude: -99.1910943078533,
    address: "Hda.Sierra Vieja No.2 Int.272 Col. Hacienda de Parque, Cuautitlán Izcalli, CUATITLÁN IZCALLI"
  },{
    distance: 0,
    code: "T086",
    cluster: "turistica",
    name: "MAZATLAN, GALERIAS MAZATLAN",
    latitude: 23.2783941563914, longitude: -106.448491921169,
    address: "AvDela Marina y AvDelfin 165 Col. Marina Mazatlan, Mazatlan, MAZATLAN"
  },{
    distance: 0,
    code: "T087",
    cluster: "bajiocold",
    name: "SAN JUAN DEL RÍO, GAL SAN JUAN",
    latitude: 20.3866325295235, longitude: -100.011947933049,
    address: "Carretera Panamericana Pte202 Col. Centro, San Juan del Rio, SAN JUAN DEL RÍO"
  },{
    distance: 0,
    code: "T088",
    cluster: "nortecold",
    name: "MTY, PLAZA FIESTA SAN AGUSTÍN",
    latitude: 25.648853453741, longitude: -100.337073453985,
    address: "Av.Batallon San Patricio 1000 Col. Residencial San Agustín, San Pedro Garza García, MTY"
  },{
    distance: 0,
    code: "T089",
    cluster: "nortecold",
    name: "PUEBLA, GALERíAS SERDÁN",
    latitude: 19.0715435387024, longitude: -98.2252940766876,
    address: "Blvd.Hermanos Serdan270 Int123 Col. Rancho Posadas, Puebla, PUEBLA"
  },{
    distance: 0,
    code: "T090",
    cluster: "centrocold",
    name: "CDMX, VÍA VALLEJO",
    latitude: 19.4874547534343, longitude: -99.1525909281293,
    address: "Calzada Vallejo 1090 A110 Col. Industrial Vallejo, Azcapotzalco, CDMX"
  },{
    distance: 0,
    code: "T091",
    cluster: "calor",
    name: "CD.DEL CARMEN, ZENTRALIA CME",
    latitude: 18.6543176272752, longitude: -91.807390952399,
    address: "Av.Corregidora 26 Int.35 Col. Aeropuerto, Carmen, CD.DEL CARMEN"
  },{
    distance: 0,
    code: "T092",
    cluster: "centrocold",
    name: "TOLUCA, GALERÍAS TOLUCA",
    latitude: 19.2890665274784, longitude: -99.6228141838874,
    address: "Avenida Paseo Tollocan SN Col. Santa Ana Tlapaltitlán, Toluca, TOLUCA"
  },{
    distance: 0,
    code: "T093",
    cluster: "centrocold",
    name: "TLALNEPANTLA, PLAZA TLALNE FM",
    latitude: 19.538330470746, longitude: -99.2060899381851,
    address: "Av.Sor Juana Inés de Cruz 280 Col. San Lorenzo Ind., Tlalnepantla de Baz, TLALNEPANTLA"
  },{
    distance: 0,
    code: "T094",
    cluster: "nortecold",
    name: "HERMOSILLO, SONORA MALL",
    latitude: 29.0661597041223, longitude: -110.950005448797,
    address: "Boulevard Cultura 55 Oriente Col. Proyecto Rio Sonora, Hermosillo, HERMOSILLO"
  },{
    distance: 0,
    code: "T095",
    cluster: "calor",
    name: "CUAUTLA, PLAZA ATRIOS",
    latitude: 18.8681024451976, longitude: -98.9516249902094,
    address: "Camino Real Tetelcingo C.23 Col. Tierra Larga, Cuautla, CUAUTLA"
  },{
    distance: 0,
    code: "T096",
    cluster: "nortecold",
    name: "TLAXCALA, GALERÍAS TLAXCALA",
    latitude: 19.290651111917, longitude: -98.2296086150474,
    address: "Av.Libramiento Pte Tlax.Km328 Sn.Sebastian Atlahapa, Tlaxcala, TLAXCALA"
  },{
    distance: 0,
    code: "T097",
    cluster: "centrocold",
    name: "NAUCALPAN, PARQUE TOREO",
    latitude: 19.4684426053398, longitude: -99.2264461055214,
    address: "Blvd.Manuel Avila Camacho No.5 Col. Lomas de Sotelo, Naucalpan, NAUCALPAN"
  },{
    distance: 0,
    code: "T098",
    cluster: "nortecold",
    name: "PUEBLA, PARQUE PUEBLA",
    latitude: 19.0694616200256, longitude: -98.1724972911808,
    address: "Clza.Ignacio Zaragoza No.410 Col. Corredor Cienega, Puebla, PUEBLA"
  },{
    distance: 0,
    code: "T099",
    cluster: "centrocold",
    name: "CDMX, PARQUE LAS ANTENAS",
    latitude: 19.314659131146, longitude: -99.0760014533927,
    address: "Av.Periferico. 3278 L78-81 Col. La Esperanza, Iztapalapa, CDMX"
  },{
    distance: 0,
    code: "T100",
    cluster: "bajiocold",
    name: "GUADALAJARA, MIDTOWN JALISCO",
    latitude: 20.69365968206383, longitude: -103.375328436197,
    address: "Av. Lopez Mateos No. 2405 L-19 Col.Italia Providencia, Guadalajara, GUADALAJARA"
  },{
    distance: 0,
    code: "T101",
    cluster: "calor",
    name: "TUXTLA GTZ PLAZA AMBAR",
    latitude: 16.7454256028642, longitude: -93.0742587828241,
    address: "Blvd.Salomon Gzlez Blanco 651 Col. El Retiro, Chiapas, TUXTLA GTZ PLAZA AMBAR"
  },{
    distance: 0,
    code: "T102",
    cluster: "calor",
    name: "TAMPICO, ALTAMA CITY CENTER",
    latitude: 22.2492362988999, longitude: -97.8645313543255,
    address: "Av.Ejercito Mexicano 706 L2007 Col. Primavera, Tamaulipas, TAMPICO"
  },{
    distance: 0,
    code: "T103",
    cluster: "bajiocold",
    name: "ZAMORA, SENTURA ZAMORA",
    latitude: 20.0268162098673, longitude: -102.276878708941,
    address: "Carr. Zamora la Barca Col. Atecuario Num. Ext 4300, ZAMORA, ZAMORA"
  },{
    distance: 0,
    code: "T104",
    cluster: "bajiocold",
    name: "FRESNILLO, PORTAL FRESNILLO",
    latitude: 23.1960911432713, longitude: -102.884314794467,
    address: "Av. Sonora Ext 1033 Int. SSA17 Col. Panamericana, Zacatecas, FRESNILLO"
  },{
    distance: 0,
    code: "T105",
    cluster: "bajiocold",
    name: "GUADALAJARA,GALERIAS STA ANITA",
    latitude: 20.5534597309267, longitude: -103.468492090482,
    address: "Av. Lopez Mateos Num.Ext. 9900 San Agustin, JAL, GUADALAJARA"
  },{
    distance: 0,
    code: "T106",
    cluster: "centrocold",
    name: "CDMX, ENCUENTRO OCEANIA",
    latitude: 19.4395375525668, longitude: -99.0941419889544,
    address: "Av. Peñon Num 355 L- MA09 Col. Moctezuma 2DA Seccion, MEX, CDMX"
  },{
    distance: 0,
    code: "T107",
    cluster: "centrocold",
    name: "VALLE DE CHALCO, PATIO CHALCO",
    latitude: 19.3002328495084, longitude: -98.9528096954523,
    address: "Blvd. Juan Pablo II Ext. 370 Col. El Agostadero, Valle de Chalco, VALLE DE CHALCO"
  },{
    distance: 0,
    code: "T108",
    cluster: "bajiocold",
    name: "GUADALAJARA, DISTRITO LA PERLA",
    latitude: 20.6447828182902, longitude: -103.412210220335,
    address: "Av. Mariano Otero Ext. 3000 Int. B111 Col. Ciudad del Sol, Zapopan, GUADALAJARA"
  },{
    distance: 0,
    code: "T109",
    cluster: "nortecold",
    name: "MONTERREY,GALERIAS MONTERREY",
    latitude: 25.6822225573808, longitude: -100.353665826597,
    address: "AV. Insurgentes Ext. 2500 Int. 972 Col. Vista Hermosa, Monterrey, MONTERREY"
  },{
    distance: 0,
    code: "T110",
    cluster: "calor",
    name: "TAPACHULA, ALAIA TAPACHULA",
    latitude: 14.8745167539777, longitude: -92.2830251417135,
    address: "Carr. a Puerto Madero No. 177 Int. L41.42 Col. Tap. Centro, TAPACHULA, TAPACHULA"
  },{
    distance: 0,
    code: "T111",
    cluster: "bajiocold",
    name: "GUANAJUATO, ALAIA GUANAJUATO",
    latitude: 20.9724783593386, longitude: -101.278765121327,
    address: "Blvd. Euquerio Guerrero No.139 Yerbabuena, Guanajuato, GUANAJUATO"
  },{
    distance: 0,
    code: "T112",
    cluster: "nortecold",
    name: "TIJUANA, PLAZA PENINSULA",
    latitude: 32.5135996773133, longitude: -116.965614645259,
    address: "Av. Via Rapida Oriente No15000 Int. SA-01A Col. Chapultepec, TIJUANA, TIJUANA"
  },{
    distance: 0,
    code: "T113",
    cluster: "centrocold",
    name: "CDMX, PARQUE TEPEYAC",
    latitude: 19.4758242563223, longitude: -99.1003425083863,
    address: "Av. Ing. Eduardo Molina #6730 Int.84-85 Col.Granjas Modernas, Gustavo A. Madero, CDMX"
  },{
    distance: 0,
    code: "T114",
    cluster: "nortecold",
    name: "MONTERREY, PASEO LA FE",
    latitude: 25.7199984336787, longitude: -100.219064116653,
    address: "Av. Miguel Aleman #200 Int. A32 A33 Col. La Talaverna, San Nicolás de los Garza, MONTERREY"
  },{
    distance: 0,
    code: "T115",
    cluster: "bajiocold",
    name: "SAN LUIS POTOSI, EL DORADO",
    latitude: 22.1552408156349, longitude: -101.004787742325,
    address: "Av. Nereo Rdgz Barragan # 45 Int. L-9-12 Col. Del Valle, SAN LUIS POTOSI, SAN LUIS POTOSI"
  },{
    distance: 0,
    code: "T116",
    cluster: "bajiocold",
    name: "GUADALAJARA, PLAZA PATRIA",
    latitude: 20.7123565354098, longitude: -103.378378473612,
    address: "Avenida Patria SN Numero Interior D7, Zapopan, GUADALAJARA"
  },{
    distance: 0,
    code: "T117",
    cluster: "centrocold",
    name: "COACALCO, COSMOPOL",
    latitude: 19.6392030939853, longitude: -99.0890654012243,
    address: "Av. Jose Lopez Portillo 1 Int E002-4 Col. San Fco. Coacalco, Coacalco de Berriozabal, COACALCO"
  },{
    distance: 0,
    code: "T118",
    cluster: "centrocold",
    name: "CDMX, MITIKAH",
    latitude: 19.3603218526801, longitude: -99.1679051662553,
    address: "Av. Real Marorazco Num. 130 Int. 2N-35. Col. Xoco, BENITO JUAREZ, CDMX"
  },{
    distance: 0,
    code: "T119",
    cluster: "nortecold",
    name: "ATLIXCO, MORALEDA",
    latitude: 18.8924661665041, longitude: -98.4260920508274,
    address: "Carr. Pue. Izucar de Matamoto 1901, Int. 128 -131, ATLIXCO, ATLIXCO"
  },{
    distance: 0,
    code: "T120",
    cluster: "nortecold",
    name: "COMITAN, PLAZA LAS FLORES",
    latitude: 16.2156138999574, longitude: -92.1297323825347,
    address: "Blvd. De las Federaciones KM 1260.50 Ext. 4021 Int. 6-9, COMITAN DE DOMINGUEZ, COMITAN",
  }
];

for (const store of shasaStores) {
  store.distance = Math.abs(store.latitude - geoIP.latitude) + Math.abs(store.longitude - geoIP.longitude);
}

shasaStores.sort((a, b) => a.distance - b.distance);